import { useQuery } from "@tanstack/react-query";

import { applicationRateCountKey } from "@/hooks/apis/queries/useApplicationRateCountQuery/constants";

import { applicationsApiHandler } from "@/services/apiHandlers/applications";
import type { IApplicationRateCountRequest } from "@/services/apiHandlers/applications/types";

const useApplicationRateCountQuery = ({
  applicationId,
}: IApplicationRateCountRequest) => {
  const {
    data: applicationRateCount = [],
    isInitialLoading: isInitialLoadingAppRateCount,
    refetch: refetchApplicationRateCount,
  } = useQuery({
    queryKey: [applicationRateCountKey, applicationId],
    queryFn: () =>
      applicationsApiHandler.getApplicationRateCount({ applicationId }),
    enabled: Boolean(applicationId),
  });

  return {
    applicationRateCount,
    isInitialLoadingAppRateCount,
    refetchApplicationRateCount,
  };
};

export default useApplicationRateCountQuery;
